<template>
    <div class="promotion-list">
        <img class="banner" src="@/assets/images/promotion/promotion-banner-mob.jpg" alt="活动宣传banner图片" />
        <div class="title" @click="pickerCtrl(true)">{{ curTitle }}</div>
        <com-picker
            :showPicker="showPicker"
            :pickerTitle="'活动选择'"
            :pickerList="pickerList"
            :selectPicker="curTitle"
            @closePicker="close"
            @confirmPicker="confirm"
        ></com-picker>
        <div class="list">
            <div v-for="item in list" :key="item.id" class="list-box">
                <img v-if="isOver(item.endTime)" class="flag" src="@/assets/images/promotion/end.png" alt="标识图片" />
                <img
                    :src="item.cover && item.cover.url"
                    :alt="item.cover && (item.cover.caption || item.cover.alternativeText || item.cover.url)"
                    class="cover"
                />
                <div class="des">
                    <div class="main-title">{{ item.title }}</div>
                    <div>
                        <span class="sub-title">{{ item.range }}</span>
                        <span class="sub-title date">{{ formatTime(item.beginTime) }} - {{ formatTime(item.endTime) }}</span>
                    </div>
                    <div class="btn" @click="goDetail(item)">查看详情</div>
                </div>
            </div>
        </div>
        <page-turn :page-sum="pages" @on-turn="onTurnPage"></page-turn>
    </div>
</template>

<script>
import ajax from '@/api/ajax'
import pageTurn from '@/components/page-turn/'
import comPicker from '@/components/comSelector'
import moment from 'moment'

export default {
    name: 'PromotionList',
    components: {
        pageTurn,
        comPicker
    },
    data() {
        return {
            list: [],
            count: 0,
            pages: 0,
            pageSize: 5,
            curPage: 1,
            pickerList: ['全部活动', '进行中', '已结束'],
            showPicker: false
        }
    },
    created() {
        this.curTitle = this.pickerList[0]
        this.loadPage(1)
        ajax.getPromotionsCount().then(res => {
            this.count = res || 0
            this.pages = Math.ceil(this.count / this.pageSize)
        })
    },
    methods: {
        formatTime(time) {
            if (!time) {
                return time
            }
            return time.replace(/-/gi, '.')
        },
        close() {
            this.pickerCtrl(false)
        },
        confirm(data) {
            this.curTitle = data
            this.pickerCtrl(false)
            this.loadPage(1)
            const now = moment(new Date()).format('YYYY-MM-DD')
            let params = {}
            if (this.curTitle === this.pickerList[1]) {
                params = { beginTime_lte: now, endTime_gte: now }
            } else if (this.curTitle === this.pickerList[2]) {
                params = {
                    '_where[_or][endTime_lt]': now
                }
            } else {
                params = {}
            }
            ajax.getPromotionsCount({ params }).then(res => {
                this.count = res || 0
                this.pages = Math.ceil(this.count / this.pageSize)
            })
        },
        pickerCtrl(flag) {
            this.showPicker = flag
        },
        goDetail(detail) {
            this.$router.push({
                path: 'detail',
                query: {
                    id: detail.id
                }
            })
        },
        isOver(time) {
            if (!time) {
                return false
            }
            return new Date().getTime() > new Date(time.replace(/-/gi, '/')).getTime()
        },
        onTurnPage(data) {
            this.loadPage(data.page)
        },
        loadPage(page) {
            const now = moment(new Date()).format('YYYY-MM-DD')
            let params = {}
            if (this.curTitle === this.pickerList[1]) {
                params = {
                    _start: this.pageSize * (page - 1),
                    _limit: this.pageSize,
                    beginTime_lte: now,
                    endTime_gte: now
                }
            } else if (this.curTitle === this.pickerList[2]) {
                params = {
                    _start: this.pageSize * (page - 1),
                    _limit: this.pageSize,
                    '_where[_or][endTime_lt]': now
                }
            } else {
                params = {
                    _start: this.pageSize * (page - 1),
                    _limit: this.pageSize
                }
            }
            this.curPage = page
            this.$loading('加载中')
            ajax.getPromotions({ params })
                .then(res => {
                    this.list = res || []
                })
                .finally(() => {
                    this.$loading()
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.promotion-list {
    .banner {
        width: 100%;
        display: block;
    }
    .title {
        font-size: 0.36rem;
        color: #333333;
        cursor: pointer;
        font-weight: bold;
        line-height: 1.2rem;
        height: 1.2rem;
        background: #f1f1f1;
        text-align: center;
        position: relative;
        .sub-title {
            position: absolute;
            background: #fff;
        }
    }
    .list {
        padding: 0 0.2rem;
        padding-bottom: 0.4rem;
        .list-box {
            border-radius: 0.08rem;
            margin-top: 0.4rem;
            background: #f1f1f1;
            padding-bottom: 0.4rem;
            position: relative;
            overflow: hidden;
            .flag {
                position: absolute;
                top: 0;
                right: 0;
                width: 1.4rem;
                height: 1.4rem;
            }
            .cover {
                width: 100%;
            }
            .des {
                padding: 0 0.3rem;
            }
            .main-title {
                font-size: 0.36rem;
                color: #333333;
                text-align: center;
                padding-top: 0.8rem;
                padding-bottom: 0.4rem;
            }
            .sub-title {
                font-size: 0.28rem;
                color: #333333;
                line-height: 0.48rem;
            }
            .date {
                margin-left: 0.4rem;
            }
            .btn {
                font-size: 0.28rem;
                display: block;
                width: 2.8rem;
                height: 0.8rem;
                line-height: 0.8rem;
                text-indent: 0.38rem;
                border: 1px solid #4d4d4d;
                color: #333333;
                margin: 0 auto;
                position: relative;
                margin-top: 0.4rem;
                background-image: url('~@/assets/images/promotion/span_right_btn.png');
                background-repeat: no-repeat;
                background-position: 1.8rem center;
            }
        }
    }
    .pagination {
        display: flex;
        padding: 0 0.2rem;
        padding-bottom: 0.4rem;
        justify-content: center;
        align-content: center;
        .page-num {
            display: inline-block;
            text-align: center;
            font-size: 0.36rem;
            color: #333333;
            margin: 0 0.2rem;
        }
        .pre {
            display: inline-block;
            height: 0.54rem;
            margin: 0 0.2rem;
            background-image: url('~@/assets/images/promotion/btn-prev.png');
            background-repeat: no-repeat;
            background-position: center;
            width: 0.4rem;
            background-position-x: 0;
        }
        .next {
            display: inline-block;
            height: 0.54rem;
            margin: 0 0.2rem;
            width: 0.4rem;
            background-image: url('~@/assets/images/promotion/btn-prev.png');
            background-repeat: no-repeat;
            background-position: center;
            background-position-x: right;
        }
        .active {
            text-decoration: underline;
            color: #dc1e32;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/promotion/list.vue